import { render, staticRenderFns } from "./FormControlPropertyEditor.vue?vue&type=template&id=d4bdc864&scoped=true&"
import script from "./FormControlPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormControlPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormControlPropertyEditor.vue?vue&type=style&index=0&id=d4bdc864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bdc864",
  null
  
)

export default component.exports